import { render, staticRenderFns } from "./PathRoute.vue?vue&type=template&id=b075d8a0&"
import script from "./PathRoute.vue?vue&type=script&lang=js&"
export * from "./PathRoute.vue?vue&type=script&lang=js&"
import style0 from "./PathRoute.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports